import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, ChevronDown, Zap, Terminal } from 'lucide-react';
export function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl" />
        <div
          className="absolute inset-0 opacity-[0.03] dark:opacity-[0.05]"
          style={{ backgroundImage: 'radial-gradient(#000 0.5px, transparent 0.5px)', backgroundSize: '24px 24px' }}
        />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 text-blue-500 text-xs font-semibold uppercase tracking-wider">
              <Zap className="w-3 h-3" />
              Direct Expert Access
            </div>
            <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-balance leading-[1.1]">
              Personal <span className="text-blue-500">IT Infrastructure</span> & Backend Support
            </h1>
            <p className="text-xl text-muted-foreground text-pretty max-w-xl">
              I provide hands-on Linux administration, cloud-native architecture, and high-performance backend development for projects that value reliability and direct communication.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button size="lg" className="h-12 px-8 text-md font-semibold" asChild>
                <a href="#contact">
                  Let's Chat <ArrowRight className="ml-2 w-4 h-4" />
                </a>
              </Button>
              <Button size="lg" variant="outline" className="h-12 px-8 text-md font-semibold" asChild>
                <a href="#services">How I Help</a>
              </Button>
            </div>
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-border/50">
              <div className="space-y-1">
                <div className="text-2xl font-bold">Direct</div>
                <div className="text-xs text-muted-foreground uppercase tracking-wider">Expert Access</div>
              </div>
              <div className="space-y-1">
                <div className="text-2xl font-bold">Proven</div>
                <div className="text-xs text-muted-foreground uppercase tracking-wider">Reliability</div>
              </div>
              <div className="space-y-1">
                <div className="text-2xl font-bold">Flexible</div>
                <div className="text-xs text-muted-foreground uppercase tracking-wider">Project Scheduling</div>
              </div>
            </div>
          </div>
          <div className="relative hidden lg:block">
            <div className="relative z-10 p-8 glass-dark rounded-3xl border border-white/10 shadow-2xl">
              <pre className="text-xs md:text-sm font-mono text-blue-400 overflow-hidden">
                <code>{`# Managed Environment
$ infrastructure status --personal
> Checking Kubernetes clusters... [OK]
> Optimizing PHP-FPM / Nginx pools... [OK]
> Verifying RabbitMQ message queues... [OK]
> Scaling via KEDA rules... [ACTIVE]
Current Focus:
- Redis Caching Optimization
- Clickhouse Analytics Tuning
- Prometheus Monitoring setup`}</code>
              </pre>
            </div>
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-blue-500/20 rounded-full blur-3xl" />
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-amber-500/20 rounded-full blur-3xl" />
          </div>
        </div>
      </div>
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-6 h-6 text-muted-foreground" />
      </div>
    </section>
  );
}